import { put, takeLatest } from "redux-saga/effects";
import { REQUEST_GEO_LOCATION, updateGeo } from "../actions/forms";

function* geoLocation(action) {
  console.log("geolocation saga");
  console.log(action);
  try {
    // const sonviList = yield SonvisAPI.getSonviList(startDate, endDate);
    const input = action.payload.locationName;
    const addr = `https://maps.googleapis.com/maps/api/geocode/json?address=${input}&key=${process.env.REACT_APP_GOOGLE_MAPS_API}`;

    const resp = yield fetch(addr);
    const response = yield resp.json();
    console.log(response.results);
    if (response.results.length > 0) {
      const { lat, lng } = response.results[0].geometry.location;
      yield put(updateGeo(lat, lng, 12));
    } else {
      console.log("Not found");
    }
    // yield put(receiveSonviList(sonviList));
  } catch (e) {
    console.log("Error inside sonvi list sagas", e.message);
    const title = "Application error";
    const content = "There was a problem with your request";
    yield put(console.log(2));
    console.log("error");
  }
}

export default function* getGeoLocationWatcher() {
  yield takeLatest(REQUEST_GEO_LOCATION, geoLocation);
}
